import styleVariables from '../styleVariables';

const sxDataGridDark = () => {
	return {
		fontSize: '0.82rem',
		border: 'none',
		margin: '0px',
		padding: '0px',
		borderRadius: '10px',
		backgroundColor: styleVariables.primaryColor,
		color: '#FFF',
		'& .MuiDataGrid-columnHeaderTitle': {
			fontSize: '0.82rem',
			color: '#FFF',
			fontWeight: 600,
			overFlow: 'visible',
		},
		'& .MuiDataGrid-iconSeparator': {
			display: 'none',
		},
		'& .row-status--true': {
			color: '#8799B4',
		},
		'& .MuiDataGrid-columnHeaders': {
			border: 'none',
		},
		'& .MuiDataGrid-cell': {
			border: 'none',
		},
		'& .MuiTablePagination-actions': {
			'& .Mui-disabled': {
				color: '#6F8098!important',
			},
		},
		'& .MuiDataGrid-footerContainer': {
			borderTop: '1px solid rgba(255,255,255,0.1)',
		},
		'& .MuiDataGrid-overlay': {
			background: 'none!important',
		},
	};
};

export default sxDataGridDark;
